module.exports = __webpack_public_path__ + "static/img/bimom_bgm.2f3fed64.jpg";